<template>
  <div class="start__materials-table pb-3">
      <div class="pb-2 pt-3">Материалы</div>
      <div class="start__materials-row" v-for="(item, index) in items" :key="index">
        <Material :choices="choices" :key="item.id" :selected.sync="item" :addFunction="addItem"/>
      </div>
    </div>
</template>

<script>
import Material from '@/components/Material.vue'

export default {
  name: 'MaterialSet',
  props: ['choices', 'materials'],
  data () {
    return {
      items: this.materials || [{}]
    }
  },
  components: {
    Material
  },
  methods: {
    validate () {
      let errorText = ''
      let cleanItems = []

      for (let idx in this.items) {
        let item = this.items[idx]
        let emptyRow = (item.id === undefined || item.id === '') && (item.amount === undefined || item.amount === '')
        if (emptyRow) {
          continue
        }
        let filledRow = (Number.isInteger(item.id) && Number.isInteger(item.amount))
        if (!filledRow) {
          errorText = 'Одна из строк заполнена частично. Если строка не нужна, оставьте материал и кол-во пустыми.'
          break
        }
        cleanItems.push(item)
      }

      if (this.hasDuplicates(cleanItems, el => el.id)) {
        errorText = 'Как минимум один из материалов дублируется. Замените другим или оставьте пустым.'
      }

      if (errorText) {
        this.$swal({ type: 'error', text: errorText })
        return [false, null]
      }

      return [true, cleanItems]
    },
    hasDuplicates (array, testFunc) {
      let valueArr = array.map(testFunc)
      let isDuplicate = valueArr.some((item, idx) => valueArr.indexOf(item) !== idx)
      return isDuplicate
    },
    addItem () {
      this.items.push({})
    }
  }
}
</script>
